export class BusinessUnit {
  businessUnitID?: string;
  tempId: string;
  name: string;
  flatName: string;
  businessUnits = new Array<BusinessUnit>();
}
